import { LoadingPageComponent } from './loading-page/loading-page.component';
import { ShellComponent } from './shell/shell.component';

export * from './shell/shell.component';
export * from './loading-page/loading-page.component';


export const components: any[] = [
    ShellComponent,
    LoadingPageComponent
];
